import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-filter-tags-top"
}
const _hoisted_2 = { class: "as-filter-tags__day" }
const _hoisted_3 = { class: "as-calendar" }
const _hoisted_4 = {
  key: 0,
  class: "as-sort-by"
}
const _hoisted_5 = { class: "as-with-by" }
const _hoisted_6 = {
  key: 1,
  class: "as-filter-country-top"
}
const _hoisted_7 = { class: "as-item-country-select-header" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "as-select-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "as-filter-tags__leagues"
}
const _hoisted_12 = ["onClick"]

import type { ITag, ILeague, IFilterResult, ICountry } from "~src/interfaces";
import IconToday from "./icons/IconToday.vue";
import DatePicker from "vue-datepicker-next";
import { ref, computed } from "vue";
import IconArrownUp from "./icons/IconArrownUp.vue";
import IconArrownDown from "./icons/IconArrownDown.vue";
import IConSort from "./icons/IConSort.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import IconCustomArrownDown from "~src/components/icons/IconCustomArrownDown.vue";
import IconCustomArrownUp from "~src/components/icons/IconCustomArrownUp.vue";
import { useClickOutside } from "~src/utils/clickOutsideHelper";

const __default__ = {};

interface IProps {
  tags: Array<ITag>;
  leagues: Array<ILeague>;
  countries: Array<ICountry>;
  filter: IFilterResult;
  sortBy: string;
  isShowSort: boolean;
  page?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FilterTags',
  props: {
    tags: {},
    leagues: {},
    countries: { default: () => [] as ICountry[] },
    filter: {},
    sortBy: {},
    isShowSort: { type: Boolean, default: true },
    page: {}
  },
  emits: [
  "changeTag",
  "changeLeague",
  "sorByTime",
  "changeCountry",
],
  setup(__props: any, { emit: __emit }) {

const commonStore = usecommonStore();

const emits = __emit;

const props = __props;

const selectHeader = ref<HTMLElement | null>(null);
const selectContent = ref<HTMLElement | null>(null);
const siteName = computed(() => commonStore.getSiteName);
const selectedDate = ref<Date>(new Date());
const dateFormat = "DD/MM/YYYY";
const isExpanded = ref(false);
const isShowContentCountries = ref(false);
const countryActive = ref<ICountry | null>(null);

const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};

const formatDateToYYYYMMDD = (date: Date): any => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return {
    day,
    month,
    year,
  };
};

const handleDateChange = (newDate: Date) => {
  selectedDate.value = newDate;
  const _value = formatDateToYYYYMMDD(newDate);
  const tag: ITag = {
    title: `${_value.day}/${_value.day}`,
    value: `${_value.year}-${_value.month}-${_value.day}`,
  };

  emits("changeTag", tag);
};

const disableFutureDates = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (props.page == "result") {
    return date > today;
  }

  return date < today;
};

const changeTag = (tag: ITag) => {
  emits("changeTag", tag);
};

const changeLeague = (league: ILeague) => {
  emits("changeLeague", league);
};

const sorByTime = () => {
  emits("sorByTime", props.sortBy === "time" ? "league" : "time");
};

const setTagsToday = (is_all: boolean = false) => {
  const newDate = new Date();
  if (!is_all) {
    selectedDate.value = newDate;
  }

  const _value = formatDateToYYYYMMDD(newDate);
  const tag: ITag = {
    title: `${_value.day}/${_value.day}`,
    value: `${_value.year}-${_value.month}-${_value.day}`,
  };

  emits("changeTag", tag);
};

const setActiveCountry = (country: ICountry | null) => {
  isShowContentCountries.value = false;
  emits("changeCountry", country);
};

const toggleContentCountries = () => {
  isShowContentCountries.value = !isShowContentCountries.value;
};

const closeCountrySelect = () => {
  isShowContentCountries.value = false;
};

useClickOutside([selectHeader, selectContent], {
  handler: closeCountrySelect,
  middleware: (event) => {
    const target = event.target as HTMLElement;

    if (target.closest(".icon-arrow")) {
      return false;
    }

    return true;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-filter-tags as-filter-tags-${siteName.value}`)
  }, [
    (_ctx.tags.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "as-today",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setTagsToday()))
            }, [
              _createVNode(IconToday, {
                fill: "#00FFFD",
                fillReact: "#00FFFD"
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" Hôm nay "))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "as-calendar-text" }, "Cụ thể", -1)),
              _createVNode(_unref(DatePicker), {
                value: selectedDate.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
                format: dateFormat,
                "disabled-date": disableFutureDates,
                placeholder: "Chọn ngày",
                onChange: handleDateChange,
                "popup-class": `api-sport api-sport-${siteName.value}`,
                "input-attr": { readonly: true }
              }, null, 8, ["value", "popup-class"])
            ])
          ]),
          (_ctx.isShowSort && _ctx.filter.tag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "as-title" }, " Sắp xếp: ", -1)),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (sorByTime()))
                }, [
                  _createElementVNode("span", _hoisted_5, " Theo " + _toDisplayString(_ctx.sortBy == "league" ? "thời gian" : "giải đấu"), 1),
                  _createVNode(IConSort)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.countries.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "as-item-country as-item-country-text" }, "Quốc gia", -1)),
          _createElementVNode("div", {
            class: "as-item-country as-item-country-select",
            onClick: toggleContentCountries,
            ref_key: "selectHeader",
            ref: selectHeader
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                (_ctx.filter.country?.id)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getImgUrlBySport('country', _ctx.filter.country?.id),
                      alt: _ctx.filter.country?.name_vi ?? ''
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.filter.country
                ? _ctx.filter.country?.name_vi ?? _ctx.filter.country?.name
                : "Tất cả"), 1)
              ]),
              (!isShowContentCountries.value)
                ? (_openBlock(), _createBlock(IconCustomArrownDown, {
                    key: 0,
                    fill: "#2FB925",
                    onClick: _withModifiers(toggleContentCountries, ["stop"])
                  }))
                : (_openBlock(), _createBlock(IconCustomArrownUp, {
                    key: 1,
                    fill: "#2FB925",
                    onClick: _withModifiers(toggleContentCountries, ["stop"])
                  }))
            ]),
            (isShowContentCountries.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "as-item-country-select-content",
                  ref_key: "selectContent",
                  ref: selectContent
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                'as-active': !_ctx.filter.country?.id,
              }),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setActiveCountry(null)))
                    }, " Tất cả ", 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: country.id,
                        onClick: ($event: any) => (setActiveCountry(country)),
                        class: _normalizeClass({
                'as-active': _ctx.filter.country?.id == country.id,
              })
                      }, _toDisplayString(country.name_vi ?? country.name), 11, _hoisted_10))
                    }), 128))
                  ])
                ], 512))
              : _createCommentVNode("", true)
          ], 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.leagues.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-tags-leagues", { 'as-is-expanded': isExpanded.value }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagues, (league) => {
              return (_openBlock(), _createElementBlock("a", {
                key: league?.id,
                class: _normalizeClass(["as-league-item", {
            'active as-active':
              league?.cur_season_id === _ctx.filter?.league?.cur_season_id,
          }]),
                onClick: () => changeLeague(league),
                href: "javascript:void(0)"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "as-before-extra" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(league.short_name_vi ? league.short_name_vi : league.short_name), 1)
              ], 10, _hoisted_12))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            class: "as-expand",
            role: "button",
            onClick: toggleExpand
          }, [
            (!isExpanded.value)
              ? (_openBlock(), _createBlock(IconArrownDown, { key: 0 }))
              : _createCommentVNode("", true),
            (isExpanded.value)
              ? (_openBlock(), _createBlock(IconArrownUp, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})